import 'lazysizes';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'lazyload';



// WEBPACK FOOTER //
// ./assets/scripts/lazyload.js